import { FormEvent, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { identityApi, type IdentityRecord } from '../../api/identity';

export function IdentityProfilePage() {
  const { id = '' } = useParams();
  const [identity, setIdentity] = useState<IdentityRecord | null>(null);
  const [givenName, setGivenName] = useState('');
  const [familyName, setFamilyName] = useState('');
  const [bio, setBio] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    void identityApi.get(id).then((data) => {
      setIdentity(data);
      setGivenName((data as IdentityRecord & { profile?: { given_name?: string } }).profile?.given_name ?? '');
      setFamilyName((data as IdentityRecord & { profile?: { family_name?: string } }).profile?.family_name ?? '');
      setBio((data as IdentityRecord & { profile?: { bio?: string } }).profile?.bio ?? '');
    }).catch((err) => setError(err instanceof Error ? err.message : 'Load failed'));
  }, [id]);

  async function onSave(e: FormEvent) {
    e.preventDefault();
    try {
      const updated = await identityApi.patch(id, { given_name: givenName, family_name: familyName, bio });
      setIdentity(updated);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Save failed');
    }
  }

  return (
    <div className="mx-auto max-w-3xl p-6">
      <Link to={`/identity/${id}`} className="text-sm text-slate-600 hover:underline">← Details</Link>
      <h1 className="mt-4 text-2xl font-semibold text-slate-900">Identity Profile</h1>
      {error && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
      {identity && (
        <form onSubmit={onSave} className="mt-6 space-y-3 rounded-xl border border-slate-200 bg-white p-4">
          <label className="block text-sm text-slate-600">Given name
            <input value={givenName} onChange={(e) => setGivenName(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
          </label>
          <label className="block text-sm text-slate-600">Family name
            <input value={familyName} onChange={(e) => setFamilyName(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
          </label>
          <label className="block text-sm text-slate-600">Bio
            <textarea value={bio} onChange={(e) => setBio(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" rows={4} />
          </label>
          <button type="submit" className="rounded-lg bg-slate-900 px-4 py-2 text-white">Save profile</button>
        </form>
      )}
    </div>
  );
}
